import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'

export default class GarageLicense extends React.Component {
  resource = '/garage_licenses'
  form_key = 'garage_license'
  defaults = {}

  // Delete lines as needed
  hide_buttons = false
  custom_actions = []
  skip_location = true

  validate = null

  foremost = null

  fee = form => 100

  columns = ({ view }) => [
    {
      name: 'Operations Type',
      selector: 'operations_type',
      searchable: true,
    },
    {
      name: 'Licence Type',
      selector: 'renewal',
      format: r => {
        if (r.renewal) {
          return 'Renewal'
        } else if (r.transfer) {
          return 'Transfer'
        } else {
          return 'New'
        }
      },
      searchable: true,
    },
  ]

  fields = form => [
    {
      name: 'renewal',
      save: true,
      hide: true,
    },
    {
      name: 'transfer',
      save: true,
      hide: true,
    },
    {
      name: 'license_type',
      label: 'What type of licence are you applying for?',
      options: ['New', 'Renewal', 'Transfer'],
      // Set the form values of renewal and transfer based on the selected option
      // This is a workaround to set the values of renewal and transfer
      callback: async (v) => {
        console.log(v)
        if (v == 'Renewal' ) {
          return { renewal: true }
        } else if (v == 'Transfer') {
          return { transfer: true }
        }
        return { renewal: false, transfer: false }
      },
      view: false,
    },
    {
      name: 'location_address',
      label: 'Address',
    },
    {
      name: 'location_island',
      label: 'Island',
      options: islands,
    },
    {
      name: 'location_desc',
      label: 'Location description',
      type: 'textarea',
    },

    "::Owner's Details",
    {
      name: 'i_am_owner',
      label: 'I am the owner',
      type: 'select:bool',
    },
    {
      name: 'owner_first_name',
      label: 'First name',
      hide: form.i_am_owner,
    },
    {
      name: 'owner_last_name',
      label: 'Last Name',
      hide: form.i_am_owner,
    },
    {
      name: 'owner_consent_desc',
      label: "Owner's consent decription",
      hide: (form.i_am_owner || form.owner_consent),
      type: 'textarea',
      required: false,
    },
    {
      name: 'owner_consent',
      label: 'Owner consent',
      type: 'select:bool',
      hide: form.i_am_owner,
    },

    ':: Manager Details',
    {
      name: 'manager_first_name',
      label: 'First name',
    },
    {
      name: 'manager_last_name',
      label: 'Last name',
    },
    {
      name: 'number_of_persons',
      label: 'Estimated number of persons engaged in operations',
      type: 'integer',
    },

    ':: Licence Details',
    {
      name: 'operations_type',
      label: 'Licence type',
      options: ['Major repairs', 'Paint and body work', "Wrecker's Yard"],
      hide: form.license_type != 'New',
    },
    {
      name: 'license_numb',
      label: 'License Number',
      hide: form.license_type == 'New',
    },
    {
      name: 'date_of_expiration',
      label: 'Licence expiry date',
      type: 'date',
      hide: form.license_type == 'New',
    },
    {
      name: 'date_of_issue',
      label: 'Issue date',
      type: 'date',
      hide: form.license_type == 'New',
    },
    {
      name: 'old_license_name',
      label: 'Name on previous license',
      hide: form.license_type != 'Transfer',
    },
    {
      name: 'old_license_operation_type',
      label: 'Previous license type',
      options: ['Major repairs', 'Paint and body work', "Wrecker's Yard"],
      hide: form.license_type == 'New',
    },
    {
      name: 'site_plan_upload',
      label: 'Site plan',
      key: 'image.1',
      type: 'file:all',
    },
  ]
  hidden_fields = () => [
    {
      name: 'pdf_upload',
      label: 'Upload pdf',
      key: 'image.0',
    },
  ]
  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
